import { useEffect } from "react";

export default function useMount(func:any,deps:any[]=[]){
    useEffect(func,deps)
}